export default "__VITE_ASSET__Dl8E3R3a__"